// Detect if dark mode is already present in the HTML structure
// Returns an object with detected dark mode status and the elements that have dark classes
export const detectInitialDarkMode = (
  doc: Document,
): {
  isDarkMode: boolean;
  elementsWithDarkClass: Element[];
} => {
  const elementsWithDarkClass: Element[] = [];

  // Check html element
  if (doc.documentElement.classList.contains("dark")) {
    elementsWithDarkClass.push(doc.documentElement);
  }

  // Check body element
  if (doc.body?.classList.contains("dark")) {
    elementsWithDarkClass.push(doc.body);
  }

  // Check direct children of body (not nested)
  if (doc.body) {
    for (const child of doc.body.children) {
      if (child.classList.contains("dark")) {
        elementsWithDarkClass.push(child);
      }
    }
  }
  const isDarkMode = elementsWithDarkClass.length > 0;

  return {
    isDarkMode,
    elementsWithDarkClass,
  };
};

// Apply dark mode to the html, remove existing theme-related attributes from all elements and apply theme only at the document root
export const applyDarkModeToHtml = (
  doc: Document,
  darkMode: boolean,
  specificElementsToClean?: Element[],
) => {
  // If specific elements are provided, clean those first
  if (specificElementsToClean) {
    for (const element of specificElementsToClean) {
      element.removeAttribute("data-theme");
      element.classList.remove("dark", "light");
    }
  }

  // Better approach - only clean html, body, and direct body children
  const elementsToClean = [
    doc.documentElement,
    doc.body,
    ...Array.from(doc.body?.children || []),
  ].filter(Boolean);

  for (const element of elementsToClean) {
    element.removeAttribute("data-theme");
    element.classList.remove("dark", "light");
  }

  // Apply theme only at the document root
  if (darkMode) {
    doc.documentElement.classList.add("dark");
    doc.documentElement.setAttribute("data-theme", "dark");
  } else {
    doc.documentElement.classList.remove("dark");
    doc.documentElement.setAttribute("data-theme", "light");
  }
};
